import { useState, useEffect } from 'react';
import { calculateSessionStats, calculateToolUsagePercentage } from '../utils/analyticsUtils';

export function useDashboardKPIs(selectedPeriod = '7 derniers jours', selectedSpace = 'personal') {
  const [sessionStats, setSessionStats] = useState(null);
  const [toolUsageStats, setToolUsageStats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const calculateKPIs = () => {
    try {
      setLoading(true);
      // Pass the selected period to the calculation function
      const stats = calculateSessionStats(selectedPeriod);
      setSessionStats(stats);

      // Calculate tool usage stats
      const toolStats = calculateToolUsagePercentage(selectedSpace);
      setToolUsageStats(toolStats);

      setError(null);
    } catch (err) {
      setError(err.message);
      console.error('Error calculating session stats:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    calculateKPIs();
  }, [selectedPeriod, selectedSpace]); // Re-run when selectedPeriod changes

  return { 
    sessionStats, 
    toolUsageStats,
    loading, 
    error, 
    refreshKPIs: calculateKPIs 
  };
}